async function getSystems(facilityId) {
    return this.api({
        url: `/cars/facility/${facilityId}/lidars`,
        method: 'GET'
    })
}

async function getCreate (facilityId) {
    return this.api({
        url: `/cars/facility/${facilityId}/lidars/create`,
        method: 'GET'
    })
}

async function getCompliance (lidarId) {
    return this.api({
        url: `/cars/lidar/${lidarId}/compliance`,
        method: 'GET'
    })
}

async function patchCompliance (lidarId, options) {
    return this.api({
        url: `/cars/lidar/${lidarId}/compliance`,
        method: 'PATCH',
        data: {...options}
    })
}

async function patchFeasibilityCompliance (lidarId, compliance) {
    return this.api({
        url: `/cars/lidar/${lidarId}/compliance`,
        method: 'PATCH',
        data: {feasibility: compliance}
    })
}

async function submitFeasibilityCompliance (lidarId, compliance) {
    return this.api({
        url: `/cars/lidar/${lidarId}/compliance`,
        method: 'POST',
        data: {feasibility: compliance}
    })
}

async function patchFeatureCompliance (lidarId, compliance) {
    return this.api({
        url: `/cars/lidar/${lidarId}/compliance`,
        method: 'PATCH',
        data: {feature: compliance}
    })
}

async function submitFeatureCompliance (lidarId, compliance) {
    return this.api({
        url: `/cars/lidar/${lidarId}/compliance`,
        method: 'POST',
        data: {feature: compliance}
    })
}

async function patchChannelCompliance (lidarId, compliance) {
    return this.api({
        url: `/cars/lidar/${lidarId}/compliance`,
        method: 'PATCH',
        data: {channel: compliance}
    })
}

async function submitChannelCompliance (lidarId, compliance) {
    return this.api({
        url: `/cars/lidar/${lidarId}/compliance`,
        method: 'POST',
        data: {channel: compliance}
    })
}

async function patchDataCompliance (lidarId, compliance) {
    return this.api({
        url: `/cars/lidar/${lidarId}/compliance`,
        method: 'PATCH',
        data: {data: compliance}
    })
}

async function submitDataCompliance (lidarId, compliance) {
    return this.api({
        url: `/cars/lidar/${lidarId}/compliance`,
        method: 'POST',
        data: {data: compliance}
    })
}

async function patchGeneralCompliance (lidarId, compliance) {
    return this.api({
        url: `/cars/lidar/${lidarId}/compliance`,
        method: 'PATCH',
        data: {general: compliance}
    })
}

async function submitGeneralCompliance (lidarId, compliance) {
    return this.api({
        url: `/cars/lidar/${lidarId}/compliance`,
        method: 'POST',
        data: {general: compliance}
    })
}


async function getSystem (lidarId) {
    return this.api({
        url: `/cars/lidar/${lidarId}`,
    })
}

async function editSystem (lidarId, options) {
    let data = {...options}
    // Filter null values
    data = Object.fromEntries(Object.entries(data).filter(([_, v]) => v != null && _ != null))

    // Filter empty SCC ID values
    data = Object.fromEntries(Object.entries(data).filter(([key, value]) => key !== 'scc' || !!value.scc_id))

    return this.api({
        url: `/cars/lidar/${lidarId}`,
        method: 'PATCH',
        data: data
    })
}

async function createSystem (facilityId, options) {
    return this.api({
        url: `/cars/facility/${facilityId}/lidars`,
        method: 'POST',
        data: Object.fromEntries(Object.entries(options).filter(([_, v]) => v != null && _ != null))
    })
}

async function getSystemChannels (lidarId) {
    return this.api({
        url: `/cars/lidar/${lidarId}/channels`,
    })
}

export default {
    pluginName: 'lidar',
    methods: {
        getSystems, getCreate,
        getCompliance, patchCompliance,
        patchFeasibilityCompliance, submitFeasibilityCompliance,
        patchFeatureCompliance, submitFeatureCompliance,
        patchChannelCompliance, submitChannelCompliance,
        patchDataCompliance, submitDataCompliance,
        patchGeneralCompliance, submitGeneralCompliance,
        getSystem, editSystem, createSystem,
        getSystemChannels
    }
}